export default [
  {
    path: '/mission-daily',
    component: () => import('./views/Index'),
    name: 'mission-daily',
    redirect: { name: 'mission-daily-list' },
    children: [
      {
        path: '',
        name: 'mission-daily-list',
        component: () => import('./views/List'),
        meta: {
          resource: 'auth',
        },
      },
      {
        path: 'detail/:daily_id',
        name: 'mission-daily-detail',
        component: () => import('./views/Detail'),
        meta: {
          resource: 'auth',
        },
      },
    ],
  },
]
